export const beneficialOwnersTranslations = {
  AC: {
    en: 'Ascension Island',
    nb: 'Ascension Island',
  },
  TA: {
    en: 'Tanzania',
    nb: 'Tanzania',
  },
  XK: {
    en: 'Kosovo',
    nb: 'Kosovo',
  },
  AD: {
    en: 'Andorra',
    nb: 'Andorra',
  },
  AE: {
    en: 'United Arab Emirates',
    nb: 'De forente arabiske emirater',
  },
  AF: {
    en: 'Afghanistan',
    nb: 'Afghanistan',
  },
  AG: {
    en: 'Antigua and Barbuda',
    nb: 'Antigua og Barbuda',
  },
  AI: {
    en: 'Anguilla',
    nb: 'Anguilla',
  },
  AL: {
    en: 'Albania',
    nb: 'Albania',
  },
  AM: {
    en: 'Armenia',
    nb: 'Armenia',
  },
  AO: {
    en: 'Angola',
    nb: 'Angola',
  },
  AQ: {
    en: 'Antarctic Treaty area',
    nb: 'Antarktistraktatområdet',
  },
  AR: {
    en: 'Argentina',
    nb: 'Argentina',
  },
  AS: {
    en: 'American Samoa',
    nb: 'Amerikansk Samoa',
  },
  AT: {
    en: 'Austria',
    nb: 'Østerrike',
  },
  AU: {
    en: 'Australia',
    nb: 'Australia',
  },
  AW: {
    en: 'Aruba',
    nb: 'Aruba',
  },
  AX: {
    en: 'Åland',
    nb: 'Åland',
  },
  AZ: {
    en: 'Azerbaijan',
    nb: 'Aserbajdsjan',
  },
  BA: {
    en: 'Bosnia and Herzegovina',
    nb: 'Bosnia-Hercegovina',
  },
  BB: {
    en: 'Barbados',
    nb: 'Barbados',
  },
  BD: {
    en: 'Bangladesh',
    nb: 'Bangladesh',
  },
  BE: {
    en: 'Belgium',
    nb: 'Belgia',
  },
  BF: {
    en: 'Burkina Faso',
    nb: 'Burkina Faso',
  },
  BG: {
    en: 'Bulgaria',
    nb: 'Bulgaria',
  },
  BH: {
    en: 'Bahrain',
    nb: 'Bahrain',
  },
  BI: {
    en: 'Burundi',
    nb: 'Burundi',
  },
  BJ: {
    en: 'Benin',
    nb: 'Benin',
  },
  BL: {
    en: 'Saint Barthélemy',
    nb: 'Saint Barthélemy',
  },
  BM: {
    en: 'Bermuda',
    nb: 'Bermuda',
  },
  BN: {
    en: 'Brunei',
    nb: 'Brunei',
  },
  BO: {
    en: 'Bolivia',
    nb: 'Bolivia',
  },
  BQ: {
    en: 'Caribbean Netherlands',
    nb: 'Karibisk Nederland',
  },
  BR: {
    en: 'Brazil',
    nb: 'Brasil',
  },
  BS: {
    en: 'The Bahamas',
    nb: 'Bahamas',
  },
  BT: {
    en: 'Bhutan',
    nb: 'Bhutan',
  },
  BV: {
    en: 'Bouvet Island',
    nb: 'Bouvetøya',
  },
  BW: {
    en: 'Botswana',
    nb: 'Botswana',
  },
  BY: {
    en: 'Belarus',
    nb: 'Hviterussland',
  },
  BZ: {
    en: 'Belize',
    nb: 'Belize',
  },
  CA: {
    en: 'Canada',
    nb: 'Canada',
  },
  CC: {
    en: 'Cocos (Keeling) Islands',
    nb: 'Kokosøyene',
  },
  CD: {
    en: 'Democratic Republic of the Congo',
    nb: 'Den demokratiske republikken Kongo',
  },
  CF: {
    en: 'Central African Republic',
    nb: 'Den sentralafrikanske republikk',
  },
  CG: {
    en: 'Republic of the Congo',
    nb: 'Republikken Kongo',
  },
  CH: {
    en: 'Switzerland',
    nb: 'Sveits',
  },
  CI: {
    en: 'Ivory Coast',
    nb: 'Elfenbenskysten',
  },
  CK: {
    en: 'Cook Islands',
    nb: 'Cookøyene',
  },
  CL: {
    en: 'Chile',
    nb: 'Chile',
  },
  CM: {
    en: 'Cameroon',
    nb: 'Kamerun',
  },
  CN: {
    en: "People's Republic of China",
    nb: 'Folkerepublikken Kina',
  },
  CO: {
    en: 'Colombia',
    nb: 'Colombia',
  },
  CR: {
    en: 'Costa Rica',
    nb: 'Costa Rica',
  },
  CU: {
    en: 'Cuba',
    nb: 'Cuba',
  },
  CV: {
    en: 'Cape Verde',
    nb: 'Kapp Verde',
  },
  CW: {
    en: 'Curaçao',
    nb: 'Curaçao',
  },
  CX: {
    en: 'Christmas Island',
    nb: 'Christmasøya',
  },
  CY: {
    en: 'Cyprus',
    nb: 'Kypros',
  },
  CZ: {
    en: 'Czech Republic',
    nb: 'Tsjekkia',
  },
  DE: {
    en: 'Germany',
    nb: 'Tyskland',
  },
  DJ: {
    en: 'Djibouti',
    nb: 'Djibouti',
  },
  DK: {
    en: 'Denmark',
    nb: 'Danmark',
  },
  DM: {
    en: 'Dominica',
    nb: 'Dominica',
  },
  DO: {
    en: 'Dominican Republic',
    nb: 'Den dominikanske republikk',
  },
  DZ: {
    en: 'Algeria',
    nb: 'Algerie',
  },
  EC: {
    en: 'Ecuador',
    nb: 'Ecuador',
  },
  EE: {
    en: 'Estonia',
    nb: 'Estland',
  },
  EG: {
    en: 'Egypt',
    nb: 'Egypt',
  },
  EH: {
    en: 'Western Sahara',
    nb: 'Vest-Sahara',
  },
  ER: {
    en: 'Eritrea',
    nb: 'Eritrea',
  },
  ES: {
    en: 'Spain',
    nb: 'Spania',
  },
  ET: {
    en: 'Ethiopia',
    nb: 'Etiopia',
  },
  FI: {
    en: 'Finland',
    nb: 'Finland',
  },
  FJ: {
    en: 'Fiji',
    nb: 'Fiji',
  },
  FK: {
    en: 'Falkland Islands',
    nb: 'Falklandsøyene',
  },
  FM: {
    en: 'Micronesia',
    nb: 'Mikronesia',
  },
  FO: {
    en: 'Faroe Islands',
    nb: 'Færøyene',
  },
  FR: {
    en: 'France',
    nb: 'Frankrike',
  },
  GA: {
    en: 'Gabon',
    nb: 'Gabon',
  },
  GB: {
    en: 'United Kingdom',
    nb: 'Storbritannia',
  },
  GD: {
    en: 'Grenada',
    nb: 'Grenada',
  },
  GE: {
    en: 'Georgia',
    nb: 'Georgia',
  },
  GF: {
    en: 'French Guiana',
    nb: 'Fransk Guyana',
  },
  GG: {
    en: 'Guernsey',
    nb: 'Guernsey',
  },
  GH: {
    en: 'Ghana',
    nb: 'Ghana',
  },
  GI: {
    en: 'Gibraltar',
    nb: 'Gibraltar',
  },
  GL: {
    en: 'Greenland',
    nb: 'Grønland',
  },
  GM: {
    en: 'Gambia',
    nb: 'Gambia',
  },
  GN: {
    en: 'Guinea',
    nb: 'Guinea',
  },
  GP: {
    en: 'Guadeloupe',
    nb: 'Guadeloupe',
  },
  GQ: {
    en: 'Equatorial Guinea',
    nb: 'Ekvatorial-Guinea',
  },
  GR: {
    en: 'Greece',
    nb: 'Hellas',
  },
  GT: {
    en: 'Guatemala',
    nb: 'Guatemala',
  },
  GU: {
    en: 'Guam',
    nb: 'Guam',
  },
  GW: {
    en: 'Guinea-Bissau',
    nb: 'Guinea-Bissau',
  },
  GY: {
    en: 'Guyana',
    nb: 'Guyana',
  },
  HK: {
    en: 'Hong Kong',
    nb: 'Hongkong',
  },
  HM: {
    en: 'Heard Island and McDonald Islands',
    nb: 'Heard- og McDonaldøyene',
  },
  HN: {
    en: 'Honduras',
    nb: 'Honduras',
  },
  HR: {
    en: 'Croatia',
    nb: 'Kroatia',
  },
  HT: {
    en: 'Haiti',
    nb: 'Haiti',
  },
  HU: {
    en: 'Hungary',
    nb: 'Ungarn',
  },
  ID: {
    en: 'Indonesia',
    nb: 'Indonesia',
  },
  IE: {
    en: 'Ireland',
    nb: 'Irland',
  },
  IL: {
    en: 'Israel',
    nb: 'Israel',
  },
  IM: {
    en: 'Isle of Man',
    nb: 'Man',
  },
  IN: {
    en: 'India',
    nb: 'India',
  },
  IO: {
    en: 'British Indian Ocean Territory',
    nb: 'Det britiske territoriet i Indiahavet',
  },
  IQ: {
    en: 'Iraq',
    nb: 'Irak',
  },
  IR: {
    en: 'Iran',
    nb: 'Iran',
  },
  IS: {
    en: 'Iceland',
    nb: 'Island',
  },
  IT: {
    en: 'Italy',
    nb: 'Italia',
  },
  JE: {
    en: 'Jersey',
    nb: 'Jersey',
  },
  JM: {
    en: 'Jamaica',
    nb: 'Jamaica',
  },
  JO: {
    en: 'Jordan',
    nb: 'Jordan',
  },
  JP: {
    en: 'Japan',
    nb: 'Japan',
  },
  KE: {
    en: 'Kenya',
    nb: 'Kenya',
  },
  KG: {
    en: 'Kyrgyzstan',
    nb: 'Kirgisistan',
  },
  KH: {
    en: 'Cambodia',
    nb: 'Kambodsja',
  },
  KI: {
    en: 'Kiribati',
    nb: 'Kiribati',
  },
  KM: {
    en: 'Comoros',
    nb: 'Komorene',
  },
  KN: {
    en: 'Saint Kitts and Nevis',
    nb: 'Saint Kitts og Nevis',
  },
  KP: {
    en: 'North Korea',
    nb: 'Nord-Korea',
  },
  KR: {
    en: 'South Korea',
    nb: 'Sør-Korea',
  },
  KW: {
    en: 'Kuwait',
    nb: 'Kuwait',
  },
  KY: {
    en: 'Cayman Islands',
    nb: 'Caymanøyene',
  },
  KZ: {
    en: 'Kazakhstan',
    nb: 'Kasakhstan',
  },
  LA: {
    en: 'Laos',
    nb: 'Laos',
  },
  LB: {
    en: 'Lebanon',
    nb: 'Libanon',
  },
  LC: {
    en: 'Saint Lucia',
    nb: 'Saint Lucia',
  },
  LI: {
    en: 'Liechtenstein',
    nb: 'Liechtenstein',
  },
  LK: {
    en: 'Sri Lanka',
    nb: 'Sri Lanka',
  },
  LR: {
    en: 'Liberia',
    nb: 'Liberia',
  },
  LS: {
    en: 'Lesotho',
    nb: 'Lesotho',
  },
  LT: {
    en: 'Lithuania',
    nb: 'Litauen',
  },
  LU: {
    en: 'Luxembourg',
    nb: 'Luxemburg',
  },
  LV: {
    en: 'Latvia',
    nb: 'Latvia',
  },
  LY: {
    en: 'Libya',
    nb: 'Libya',
  },
  MA: {
    en: 'Morocco',
    nb: 'Marokko',
  },
  MC: {
    en: 'Monaco',
    nb: 'Monaco',
  },
  MD: {
    en: 'Moldova',
    nb: 'Moldova',
  },
  ME: {
    en: 'Montenegro',
    nb: 'Montenegro',
  },
  MF: {
    en: 'Saint Martin',
    nb: 'Saint Martin',
  },
  MG: {
    en: 'Madagascar',
    nb: 'Madagaskar',
  },
  MH: {
    en: 'Marshall Islands',
    nb: 'Marshalløyene',
  },
  MK: {
    en: 'North Macedonia',
    nb: 'Nord-Makedonia',
  },
  ML: {
    en: 'Mali',
    nb: 'Mali',
  },
  MM: {
    en: 'Myanmar',
    nb: 'Myanmar',
  },
  MN: {
    en: 'Mongolia',
    nb: 'Mongolia',
  },
  MO: {
    en: 'Macau',
    nb: 'Macao',
  },
  MP: {
    en: 'Northern Mariana Islands',
    nb: 'Nord-Marianene',
  },
  MQ: {
    en: 'Martinique',
    nb: 'Martinique',
  },
  MR: {
    en: 'Mauritania',
    nb: 'Mauritania',
  },
  MS: {
    en: 'Montserrat',
    nb: 'Montserrat',
  },
  MT: {
    en: 'Malta',
    nb: 'Malta',
  },
  MU: {
    en: 'Mauritius',
    nb: 'Mauritius',
  },
  MV: {
    en: 'Maldives',
    nb: 'Maldivene',
  },
  MW: {
    en: 'Malawi',
    nb: 'Malawi',
  },
  MX: {
    en: 'Mexico',
    nb: 'Mexico',
  },
  MY: {
    en: 'Malaysia',
    nb: 'Malaysia',
  },
  MZ: {
    en: 'Mozambique',
    nb: 'Mosambik',
  },
  NA: {
    en: 'Namibia',
    nb: 'Namibia',
  },
  NC: {
    en: 'New Caledonia',
    nb: 'Ny-Caledonia',
  },
  NE: {
    en: 'Niger',
    nb: 'Niger',
  },
  NF: {
    en: 'Norfolk Island',
    nb: 'Norfolkøya',
  },
  NG: {
    en: 'Nigeria',
    nb: 'Nigeria',
  },
  NI: {
    en: 'Nicaragua',
    nb: 'Nicaragua',
  },
  NL: {
    en: 'Netherlands',
    nb: 'Nederland',
  },
  NO: {
    en: 'Norway',
    nb: 'Norge',
  },
  NP: {
    en: 'Nepal',
    nb: 'Nepal',
  },
  NR: {
    en: 'Nauru',
    nb: 'Nauru',
  },
  NU: {
    en: 'Niue',
    nb: 'Niue',
  },
  NZ: {
    en: 'New Zealand',
    nb: 'New Zealand',
  },
  OM: {
    en: 'Oman',
    nb: 'Oman',
  },
  PA: {
    en: 'Panama',
    nb: 'Panama',
  },
  PE: {
    en: 'Peru',
    nb: 'Peru',
  },
  PF: {
    en: 'French Polynesia',
    nb: 'Fransk Polynesia',
  },
  PG: {
    en: 'Papua New Guinea',
    nb: 'Papua Ny-Guinea',
  },
  PH: {
    en: 'Philippines',
    nb: 'Filippinene',
  },
  PK: {
    en: 'Pakistan',
    nb: 'Pakistan',
  },
  PL: {
    en: 'Poland',
    nb: 'Polen',
  },
  PM: {
    en: 'Saint Pierre and Miquelon',
    nb: 'Saint Pierre og Miquelon',
  },
  PN: {
    en: 'Pitcairn Islands',
    nb: 'Pitcairnøyene',
  },
  PR: {
    en: 'Puerto Rico',
    nb: 'Puerto Rico',
  },
  PT: {
    en: 'Portugal',
    nb: 'Portugal',
  },
  PW: {
    en: 'Palau',
    nb: 'Palau',
  },
  PY: {
    en: 'Paraguay',
    nb: 'Paraguay',
  },
  QA: {
    en: 'Qatar',
    nb: 'Qatar',
  },
  RE: {
    en: 'Réunion',
    nb: 'Réunion',
  },
  RO: {
    en: 'Romania',
    nb: 'Romania',
  },
  RS: {
    en: 'Serbia',
    nb: 'Serbia',
  },
  RU: {
    en: 'Russia',
    nb: 'Russland',
  },
  RW: {
    en: 'Rwanda',
    nb: 'Rwanda',
  },
  SA: {
    en: 'Saudi Arabia',
    nb: 'Saudi-Arabia',
  },
  SB: {
    en: 'Solomon Islands',
    nb: 'Salomonøyene',
  },
  SC: {
    en: 'Seychelles',
    nb: 'Seychellene',
  },
  SD: {
    en: 'Sudan',
    nb: 'Sudan',
  },
  SE: {
    en: 'Sweden',
    nb: 'Sverige',
  },
  SG: {
    en: 'Singapore',
    nb: 'Singapore',
  },
  SH: {
    en: 'Saint Helena',
    nb: 'Saint Helena',
  },
  SI: {
    en: 'Slovenia',
    nb: 'Slovenia',
  },
  SJ: {
    en: 'Svalbard and Jan Mayen',
    nb: 'Svalbard og Jan Mayen',
  },
  SK: {
    en: 'Slovakia',
    nb: 'Slovakia',
  },
  SL: {
    en: 'Sierra Leone',
    nb: 'Sierra Leone',
  },
  SM: {
    en: 'San Marino',
    nb: 'San Marino',
  },
  SN: {
    en: 'Senegal',
    nb: 'Senegal',
  },
  SO: {
    en: 'Somalia',
    nb: 'Somalia',
  },
  SR: {
    en: 'Suriname',
    nb: 'Surinam',
  },
  SS: {
    en: 'South Sudan',
    nb: 'Sør-Sudan',
  },
  ST: {
    en: 'São Tomé and Príncipe',
    nb: 'São Tomé og Príncipe',
  },
  SV: {
    en: 'El Salvador',
    nb: 'El Salvador',
  },
  SX: {
    en: 'Sint Maarten',
    nb: 'Sint Maarten',
  },
  SY: {
    en: 'Syria',
    nb: 'Syria',
  },
  SZ: {
    en: 'Eswatini',
    nb: 'Eswatini',
  },
  TC: {
    en: 'Turks and Caicos Islands',
    nb: 'Turks- og Caicosøyene',
  },
  TD: {
    en: 'Chad',
    nb: 'Tsjad',
  },
  TF: {
    en: 'French Southern and Antarctic Lands',
    nb: 'Franske sør- og antarktiske områder',
  },
  TG: {
    en: 'Togo',
    nb: 'Togo',
  },
  TH: {
    en: 'Thailand',
    nb: 'Thailand',
  },
  TJ: {
    en: 'Tajikistan',
    nb: 'Tadsjikistan',
  },
  TK: {
    en: 'Tokelau',
    nb: 'Tokelau',
  },
  TL: {
    en: 'Timor-Leste',
    nb: 'Øst-Timor',
  },
  TM: {
    en: 'Turkmenistan',
    nb: 'Turkmenistan',
  },
  TN: {
    en: 'Tunisia',
    nb: 'Tunisia',
  },
  TO: {
    en: 'Tonga',
    nb: 'Tonga',
  },
  TR: {
    en: 'Turkey',
    nb: 'Tyrkia',
  },
  TT: {
    en: 'Trinidad and Tobago',
    nb: 'Trinidad og Tobago',
  },
  TV: {
    en: 'Tuvalu',
    nb: 'Tuvalu',
  },
  TZ: {
    en: 'Tanzania',
    nb: 'Tanzania',
  },
  UA: {
    en: 'Ukraine',
    nb: 'Ukraina',
  },
  UG: {
    en: 'Uganda',
    nb: 'Uganda',
  },
  UM: {
    en: 'United States Minor Outlying Islands',
    nb: 'De amerikanske øyene',
  },
  US: {
    en: 'United States',
    nb: 'USA',
  },
  UY: {
    en: 'Uruguay',
    nb: 'Uruguay',
  },
  UZ: {
    en: 'Uzbekistan',
    nb: 'Usbekistan',
  },
  GS: {
    en: 'South Georgia and the South Sandwich Islands',
    nb: 'Sør-Georgia og Sør-Sandwichøyene',
  },
  PS: {
    en: 'Palestine, State of',
    nb: 'Palestina',
  },
  TW: {
    en: 'Taiwan',
    nb: 'Taiwan',
  },
  VA: {
    en: 'Holy See',
    nb: 'Den hellige stol',
  },
  VC: {
    en: 'Saint Vincent and the Grenadines',
    nb: 'Saint Vincent og Grenadinene',
  },
  VE: {
    en: 'Venezuela, Bolivarian Republic of',
    nb: 'Venezuela',
  },
  VG: {
    en: 'Virgin Islands, British',
    nb: 'De britiske Jomfruøyene',
  },
  VI: {
    en: 'Virgin Islands, U.S.',
    nb: 'De amerikanske Jomfruøyene',
  },
  VN: {
    en: 'Vietnam',
    nb: 'Vietnam',
  },
  VU: {
    en: 'Vanuatu',
    nb: 'Vanuatu',
  },
  WF: {
    en: 'Wallis and Futuna',
    nb: 'Wallis og Futuna',
  },
  WS: {
    en: 'Samoa',
    nb: 'Samoa',
  },
  YE: {
    en: 'Yemen',
    nb: 'Jemen',
  },
  YT: {
    en: 'Mayotte',
    nb: 'Mayotte',
  },
  ZA: {
    en: 'South Africa',
    nb: 'Sør-Afrika',
  },
  ZM: {
    en: 'Zambia',
    nb: 'Zambia',
  },
  ZW: {
    en: 'Zimbabwe',
    nb: 'Zimbabwe',
  },
  ABW: {
    en: 'Aruba',
    nb: 'Aruba',
  },
  AFG: {
    en: 'Afghanistan',
    nb: 'Afghanistan',
  },
  AGO: {
    en: 'Angola',
    nb: 'Angola',
  },
  AIA: {
    en: 'Anguilla',
    nb: 'Anguilla',
  },
  ALA: {
    en: 'Åland Islands',
    nb: 'Åland Islands',
  },
  ALB: {
    en: 'Albania',
    nb: 'Albania',
  },
  AND: {
    en: 'Andorra',
    nb: 'Andorra',
  },
  ARE: {
    en: 'United Arab Emirates',
    nb: 'De forente arabiske emirater',
  },
  ARG: {
    en: 'Argentina',
    nb: 'Argentina',
  },
  ARM: {
    en: 'Armenia',
    nb: 'Armenia',
  },
  ASM: {
    en: 'American Samoa',
    nb: 'Amerikansk Samoa',
  },
  ATA: {
    en: 'Antarctica',
    nb: 'Antarktis',
  },
  ATF: {
    en: 'French Southern Territories',
    nb: 'Franske sørlige territorier',
  },
  ATG: {
    en: 'Antigua and Barbuda',
    nb: 'Antigua og Barbuda',
  },
  AUS: {
    en: 'Australia',
    nb: 'Australia',
  },
  AUT: {
    en: 'Austria',
    nb: 'Østerrike',
  },
  AZE: {
    en: 'Azerbaijan',
    nb: 'Aserbajdsjan',
  },
  BDI: {
    en: 'Burundi',
    nb: 'Burundi',
  },
  BEL: {
    en: 'Belgium',
    nb: 'Belgia',
  },
  BEN: {
    en: 'Benin',
    nb: 'Benin',
  },
  BES: {
    en: 'Bonaire, Sint Eustatius and Saba',
    nb: 'Bonaire, Sint Eustatius og Saba',
  },
  BFA: {
    en: 'Burkina Faso',
    nb: 'Burkina Faso',
  },
  BGD: {
    en: 'Bangladesh',
    nb: 'Bangladesh',
  },
  BGR: {
    en: 'Bulgaria',
    nb: 'Bulgaria',
  },
  BHR: {
    en: 'Bahrain',
    nb: 'Bahrain',
  },
  BHS: {
    en: 'Bahamas',
    nb: 'Bahamas',
  },
  BIH: {
    en: 'Bosnia and Herzegovina',
    nb: 'Bosnia-Hercegovina',
  },
  BLM: {
    en: 'Saint Barthélemy',
    nb: 'Saint Barthélemy',
  },
  BLR: {
    en: 'Belarus',
    nb: 'Hviterussland',
  },
  BLZ: {
    en: 'Belize',
    nb: 'Belize',
  },
  BMU: {
    en: 'Bermuda',
    nb: 'Bermuda',
  },
  BOL: {
    en: 'Bolivia, Plurinational State of',
    nb: 'Bolivia, den plurinasjonale staten',
  },
  BRA: {
    en: 'Brazil',
    nb: 'Brasil',
  },
  BRB: {
    en: 'Barbados',
    nb: 'Barbados',
  },
  BRN: {
    en: 'Brunei Darussalam',
    nb: 'Brunei Darussalam',
  },
  BTN: {
    en: 'Bhutan',
    nb: 'Bhutan',
  },
  BVT: {
    en: 'Bouvet Island',
    nb: 'Bouvetøya',
  },
  BWA: {
    en: 'Botswana',
    nb: 'Botswana',
  },
  CAF: {
    en: 'Central African Republic',
    nb: 'Den sentralafrikanske republikken',
  },
  CAN: {
    en: 'Canada',
    nb: 'Canada',
  },
  CCK: {
    en: 'Cocos (Keeling) Islands',
    nb: 'Cocos (Keeling) øyene',
  },
  CHE: {
    en: 'Switzerland',
    nb: 'Sveits',
  },
  CHL: {
    en: 'Chile',
    nb: 'Chile',
  },
  CHN: {
    en: 'China',
    nb: 'Kina',
  },
  CIV: {
    en: "Côte d'Ivoire",
    nb: 'Elfenbenskysten',
  },
  CMR: {
    en: 'Cameroon',
    nb: 'Kamerun',
  },
  COD: {
    en: 'Congo, the Democratic Republic of the',
    nb: 'Kongo, Den demokratiske republikken Kongo',
  },
  COG: {
    en: 'Congo',
    nb: 'Kongo',
  },
  COK: {
    en: 'Cook Islands',
    nb: 'Cookøyene',
  },
  COL: {
    en: 'Colombia',
    nb: 'Colombia',
  },
  COM: {
    en: 'Comoros',
    nb: 'Komorene',
  },
  CPV: {
    en: 'Cabo Verde',
    nb: 'Kapp Verde',
  },
  CRI: {
    en: 'Costa Rica',
    nb: 'Costa Rica',
  },
  CUB: {
    en: 'Cuba',
    nb: 'Cuba',
  },
  CUW: {
    en: 'Curaçao',
    nb: 'Curaçao',
  },
  CXR: {
    en: 'Christmas Island',
    nb: 'Christmas Island',
  },
  CYM: {
    en: 'Cayman Islands',
    nb: 'Caymanøyene',
  },
  CYP: {
    en: 'Cyprus',
    nb: 'Kypros',
  },
  CZE: {
    en: 'Czechia',
    nb: 'Tsjekkia',
  },
  DEU: {
    en: 'Germany',
    nb: 'Tyskland',
  },
  DJI: {
    en: 'Djibouti',
    nb: 'Djibouti',
  },
  DMA: {
    en: 'Dominica',
    nb: 'Dominica',
  },
  DNK: {
    en: 'Denmark',
    nb: 'Danmark',
  },
  DOM: {
    en: 'Dominican Republic',
    nb: 'Den dominikanske republikk',
  },
  DZA: {
    en: 'Algeria',
    nb: 'Algerie',
  },
  ECU: {
    en: 'Ecuador',
    nb: 'Ecuador',
  },
  EGY: {
    en: 'Egypt',
    nb: 'Egypt',
  },
  ERI: {
    en: 'Eritrea',
    nb: 'Eritrea',
  },
  ESH: {
    en: 'Western Sahara',
    nb: 'Vest-Sahara',
  },
  ESP: {
    en: 'Spain',
    nb: 'Spania',
  },
  EST: {
    en: 'Estonia',
    nb: 'Estland',
  },
  ETH: {
    en: 'Ethiopia',
    nb: 'Etiopia',
  },
  FIN: {
    en: 'Finland',
    nb: 'Finland',
  },
  FJI: {
    en: 'Fiji',
    nb: 'Fiji',
  },
  FLK: {
    en: 'Falkland Islands (Malvinas)',
    nb: 'Falklandsøyene (Malvinas)',
  },
  FRA: {
    en: 'France',
    nb: 'Frankrike',
  },
  FRO: {
    en: 'Faroe Islands',
    nb: 'Færøyene',
  },
  FSM: {
    en: 'Micronesia, Federated States of',
    nb: 'Mikronesia, de fødererte statene',
  },
  GAB: {
    en: 'Gabon',
    nb: 'Gabon',
  },
  GBR: {
    en: 'United Kingdom',
    nb: 'Storbritannia',
  },
  GEO: {
    en: 'Georgia',
    nb: 'Georgia',
  },
  GGY: {
    en: 'Guernsey',
    nb: 'Guernsey',
  },
  GHA: {
    en: 'Ghana',
    nb: 'Ghana',
  },
  GIB: {
    en: 'Gibraltar',
    nb: 'Gibraltar',
  },
  GIN: {
    en: 'Guinea',
    nb: 'Guinea',
  },
  GLP: {
    en: 'Guadeloupe',
    nb: 'Guadeloupe',
  },
  GMB: {
    en: 'Gambia',
    nb: 'Gambia',
  },
  GNB: {
    en: 'Guinea-Bissau',
    nb: 'Guinea-Bissau',
  },
  GNQ: {
    en: 'Equatorial Guinea',
    nb: 'Ekvatorial-Guinea',
  },
  GRC: {
    en: 'Greece',
    nb: 'Hellas',
  },
  GRD: {
    en: 'Grenada',
    nb: 'Grenada',
  },
  GRL: {
    en: 'Greenland',
    nb: 'Grønland',
  },
  GTM: {
    en: 'Guatemala',
    nb: 'Guatemala',
  },
  GUF: {
    en: 'French Guiana',
    nb: 'Fransk Guyana',
  },
  GUM: {
    en: 'Guam',
    nb: 'Guam',
  },
  GUY: {
    en: 'Guyana',
    nb: 'Guyana',
  },
  HKG: {
    en: 'Hong Kong',
    nb: 'Hong Kong',
  },
  HMD: {
    en: 'Heard Island and McDonald Islands',
    nb: 'Heard Island og McDonaldøyene',
  },
  HND: {
    en: 'Honduras',
    nb: 'Honduras',
  },
  HRV: {
    en: 'Croatia',
    nb: 'Kroatia',
  },
  HTI: {
    en: 'Haiti',
    nb: 'Haiti',
  },
  HUN: {
    en: 'Hungary',
    nb: 'Ungarn',
  },
  IDN: {
    en: 'Indonesia',
    nb: 'Indonesia',
  },
  IMN: {
    en: 'Isle of Man',
    nb: 'Isle of Man',
  },
  IND: {
    en: 'India',
    nb: 'India',
  },
  IOT: {
    en: 'British Indian Ocean Territory',
    nb: 'Britiske Indiske Ocean-territoriet',
  },
  IRL: {
    en: 'Ireland',
    nb: 'Irland',
  },
  IRN: {
    en: 'Iran, Islamic Republic of',
    nb: 'Iran, den islamske republikken',
  },
  IRQ: {
    en: 'Iraq',
    nb: 'Irak',
  },
  ISL: {
    en: 'Iceland',
    nb: 'Island',
  },
  ISR: {
    en: 'Israel',
    nb: 'Israel',
  },
  ITA: {
    en: 'Italy',
    nb: 'Italia',
  },
  JAM: {
    en: 'Jamaica',
    nb: 'Jamaica',
  },
  JEY: {
    en: 'Jersey',
    nb: 'Jersey',
  },
  JOR: {
    en: 'Jordan',
    nb: 'Jordan',
  },
  JPN: {
    en: 'Japan',
    nb: 'Japan',
  },
  KAZ: {
    en: 'Kazakhstan',
    nb: 'Kasakhstan',
  },
  KEN: {
    en: 'Kenya',
    nb: 'Kenya',
  },
  KGZ: {
    en: 'Kyrgyzstan',
    nb: 'Kirgisistan',
  },
  KHM: {
    en: 'Cambodia',
    nb: 'Kambodsja',
  },
  KIR: {
    en: 'Kiribati',
    nb: 'Kiribati',
  },
  KNA: {
    en: 'Saint Kitts and Nevis',
    nb: 'Saint Kitts og Nevis',
  },
  KOR: {
    en: 'Korea, Republic of',
    nb: 'Sør-Korea',
  },
  KOS: {
    en: 'Kosovo',
    nb: 'Kosovo',
  },
  KWT: {
    en: 'Kuwait',
    nb: 'Kuwait',
  },
  LAO: {
    en: "Lao People's Democratic Republic",
    nb: 'Laos, folkerepublikken',
  },
  LBN: {
    en: 'Lebanon',
    nb: 'Libanon',
  },
  LBR: {
    en: 'Liberia',
    nb: 'Liberia',
  },
  LBY: {
    en: 'Libya',
    nb: 'Libya',
  },
  LCA: {
    en: 'Saint Lucia',
    nb: 'Saint Lucia',
  },
  LIE: {
    en: 'Liechtenstein',
    nb: 'Liechtenstein',
  },
  LKA: {
    en: 'Sri Lanka',
    nb: 'Sri Lanka',
  },
  LSO: {
    en: 'Lesotho',
    nb: 'Lesotho',
  },
  LTU: {
    en: 'Lithuania',
    nb: 'Litauen',
  },
  LUX: {
    en: 'Luxembourg',
    nb: 'Luxembourg',
  },
  LVA: {
    en: 'Latvia',
    nb: 'Latvia',
  },
  MAC: {
    en: 'Macao',
    nb: 'Macao',
  },
  MAF: {
    en: 'Saint Martin (French part)',
    nb: 'Saint Martin (fransk del)',
  },
  MAR: {
    en: 'Morocco',
    nb: 'Marokko',
  },
  MCO: {
    en: 'Monaco',
    nb: 'Monaco',
  },
  MDA: {
    en: 'Moldova',
    nb: 'Moldova',
  },
  MDG: {
    en: 'Madagascar',
    nb: 'Madagaskar',
  },
  MDV: {
    en: 'Maldives',
    nb: 'Maldivene',
  },
  MEX: {
    en: 'Mexico',
    nb: 'Mexico',
  },
  MHL: {
    en: 'Marshall Islands',
    nb: 'Marshalløyene',
  },
  MKD: {
    en: 'North Macedonia',
    nb: 'Nord-Makedonia',
  },
  MLI: {
    en: 'Mali',
    nb: 'Mali',
  },
  MLT: {
    en: 'Malta',
    nb: 'Malta',
  },
  MNE: {
    en: 'Montenegro',
    nb: 'Montenegro',
  },
  MNG: {
    en: 'Mongolia',
    nb: 'Mongolia',
  },
  MOZ: {
    en: 'Mozambique',
    nb: 'Mosambik',
  },
  MMR: {
    en: 'Myanmar',
    nb: 'Myanmar',
  },
  NAM: {
    en: 'Namibia',
    nb: 'Namibia',
  },
  NRU: {
    en: 'Nauru',
    nb: 'Nauru',
  },
  NCL: {
    en: 'New Caledonia',
    nb: 'Ny-Kaledonia',
  },
  NER: {
    en: 'Niger',
    nb: 'Niger',
  },
  NGA: {
    en: 'Nigeria',
    nb: 'Nigeria',
  },
  NIC: {
    en: 'Nicaragua',
    nb: 'Nicaragua',
  },
  NIU: {
    en: 'Niue',
    nb: 'Niue',
  },
  NLD: {
    en: 'Netherlands',
    nb: 'Nederland',
  },
  NOR: {
    en: 'Norway',
    nb: 'Norge',
  },
  NPL: {
    en: 'Nepal',
    nb: 'Nepal',
  },
  NZL: {
    en: 'New Zealand',
    nb: 'New Zealand',
  },
  OMN: {
    en: 'Oman',
    nb: 'Oman',
  },
  PAK: {
    en: 'Pakistan',
    nb: 'Pakistan',
  },
  PAN: {
    en: 'Panama',
    nb: 'Panama',
  },
  PER: {
    en: 'Peru',
    nb: 'Peru',
  },
  PHL: {
    en: 'Philippines',
    nb: 'Filippinene',
  },
  PLW: {
    en: 'Palau',
    nb: 'Palau',
  },
  PNG: {
    en: 'Papua New Guinea',
    nb: 'Papua Ny-Guinea',
  },
  POL: {
    en: 'Poland',
    nb: 'Polen',
  },
  PRI: {
    en: 'Puerto Rico',
    nb: 'Puerto Rico',
  },
  PRK: {
    en: 'North Korea',
    nb: 'Nord-Korea',
  },
  PRT: {
    en: 'Portugal',
    nb: 'Portugal',
  },
  PRY: {
    en: 'Paraguay',
    nb: 'Paraguay',
  },
  PSE: {
    en: 'Palestine',
    nb: 'Palestina',
  },
  PYF: {
    en: 'French Polynesia',
    nb: 'Fransk Polynesia',
  },
  QAT: {
    en: 'Qatar',
    nb: 'Qatar',
  },
  REU: {
    en: 'Réunion',
    nb: 'Réunion',
  },
  ROU: {
    en: 'Romania',
    nb: 'Romania',
  },
  RUS: {
    en: 'Russia',
    nb: 'Russland',
  },
  RWA: {
    en: 'Rwanda',
    nb: 'Rwanda',
  },
  SAU: {
    en: 'Saudi Arabia',
    nb: 'Saudi-Arabia',
  },
  SDN: {
    en: 'Sudan',
    nb: 'Sudan',
  },
  SEN: {
    en: 'Senegal',
    nb: 'Senegal',
  },
  SGP: {
    en: 'Singapore',
    nb: 'Singapore',
  },
  SHN: {
    en: 'Saint Helena',
    nb: 'Saint Helena',
  },
  SJM: {
    en: 'Svalbard and Jan Mayen',
    nb: 'Svalbard og Jan Mayen',
  },
  SLB: {
    en: 'Solomon Islands',
    nb: 'Salomonøyene',
  },
  SLE: {
    en: 'Sierra Leone',
    nb: 'Sierra Leone',
  },
  SLV: {
    en: 'El Salvador',
    nb: 'El Salvador',
  },
  SMR: {
    en: 'San Marino',
    nb: 'San Marino',
  },
  SOM: {
    en: 'Somalia',
    nb: 'Somalia',
  },
  SPM: {
    en: 'Saint Pierre and Miquelon',
    nb: 'Saint Pierre og Miquelon',
  },
  SRB: {
    en: 'Serbia',
    nb: 'Serbia',
  },
  SSD: {
    en: 'South Sudan',
    nb: 'Sør-Sudan',
  },
  STP: {
    en: 'São Tomé and Príncipe',
    nb: 'São Tomé og Príncipe',
  },
  SUR: {
    en: 'Suriname',
    nb: 'Surinam',
  },
  SVK: {
    en: 'Slovakia',
    nb: 'Slovakia',
  },
  SVN: {
    en: 'Slovenia',
    nb: 'Slovenia',
  },
  SWE: {
    en: 'Sweden',
    nb: 'Sverige',
  },
  SWZ: {
    en: 'Swaziland',
    nb: 'Swaziland',
  },
  SXM: {
    en: 'Sint Maarten (Dutch part)',
    nb: 'Sint Maarten (hollandsk del)',
  },
  SYR: {
    en: 'Syria',
    nb: 'Syria',
  },
  TCA: {
    en: 'Turks and Caicos Islands',
    nb: 'Turks- og Caicosøyene',
  },
  TCD: {
    en: 'Chad',
    nb: 'Tsjad',
  },
  TGO: {
    en: 'Togo',
    nb: 'Togo',
  },
  THA: {
    en: 'Thailand',
    nb: 'Thailand',
  },
  TJK: {
    en: 'Tajikistan',
    nb: 'Tadsjikistan',
  },
  TKL: {
    en: 'Tokelau',
    nb: 'Tokelau',
  },
  TKM: {
    en: 'Turkmenistan',
    nb: 'Turkmenistan',
  },
  TLS: {
    en: 'Timor-Leste',
    nb: 'Øst-Timor',
  },
  TON: {
    en: 'Tonga',
    nb: 'Tonga',
  },
  TTO: {
    en: 'Trinidad and Tobago',
    nb: 'Trinidad og Tobago',
  },
  TUN: {
    en: 'Tunisia',
    nb: 'Tunisia',
  },
  TUR: {
    en: 'Turkey',
    nb: 'Tyrkia',
  },
  TUV: {
    en: 'Tuvalu',
    nb: 'Tuvalu',
  },
  TWN: {
    en: 'Taiwan',
    nb: 'Taiwan',
  },
  TZA: {
    en: 'Tanzania',
    nb: 'Tanzania',
  },
  UGA: {
    en: 'Uganda',
    nb: 'Uganda',
  },
  UKR: {
    en: 'Ukraine',
    nb: 'Ukraina',
  },
  URY: {
    en: 'Uruguay',
    nb: 'Uruguay',
  },
  USA: {
    en: 'United States of America',
    nb: 'USA',
  },
  UZB: {
    en: 'Uzbekistan',
    nb: 'Usbekistan',
  },
  VAT: {
    en: 'Vatican City',
    nb: 'Vatikanstaten',
  },
  VEN: {
    en: 'Venezuela',
    nb: 'Venezuela',
  },
  VGB: {
    en: 'British Virgin Islands',
    nb: 'De britiske Jomfruøyene',
  },
  VIR: {
    en: 'U.S. Virgin Islands',
    nb: 'De amerikanske Jomfruøyene',
  },
  VNM: {
    en: 'Vietnam',
    nb: 'Vietnam',
  },
  VUT: {
    en: 'Vanuatu',
    nb: 'Vanuatu',
  },
  WLF: {
    en: 'Wallis and Futuna',
    nb: 'Wallis og Futuna',
  },
  WSM: {
    en: 'Samoa',
    nb: 'Samoa',
  },
  YEM: {
    en: 'Yemen',
    nb: 'Jemen',
  },
  ZAF: {
    en: 'South Africa',
    nb: 'Sør-Afrika',
  },
  ZMB: {
    en: 'Zambia',
    nb: 'Zambia',
  },
  ZWE: {
    en: 'Zimbabwe',
    nb: 'Zimbabwe',
  },
  MNP: {
    en: 'Northern Mariana Islands',
    nb: 'Nord-Marianene',
  },
  MRT: {
    en: 'Mauritania',
    nb: 'Mauritania',
  },
  MSR: {
    en: 'Montserrat',
    nb: 'Montserrat',
  },
  MTQ: {
    en: 'Martinique',
    nb: 'Martinique',
  },
  MUS: {
    en: 'Mauritius',
    nb: 'Mauritius',
  },
  MWI: {
    en: 'Malawi',
    nb: 'Malawi',
  },
  MYS: {
    en: 'Malaysia',
    nb: 'Malaysia',
  },
  MYT: {
    en: 'Mayotte',
    nb: 'Mayotte',
  },
  NFK: {
    en: 'Norfolk Island',
    nb: 'Norfolkøya',
  },
  PCN: {
    en: 'Pitcairn Islands',
    nb: 'Pitcairnøyene',
  },
  SGS: {
    en: 'South Georgia and the South Sandwich Islands',
    nb: 'Sør-Georgia og Sør-Sandwichøyene',
  },
  SYC: {
    en: 'Seychelles',
    nb: 'Seychellene',
  },
  UMI: {
    en: 'United States Minor Outlying Islands',
    nb: 'USAs ytre småøyer',
  },
  VCT: {
    en: 'Saint Vincent and the Grenadines',
    nb: 'Saint Vincent og Grenadinene',
  },
};
